<template>
  <section :class="contentClasses">
     <div class="row">
      <div class="col-12">
        <!-- <search-scope-select-bar v-if="useCombinedSearch" :config="searchFiltersConfig" /> -->
        <search-scope-select-bar v-if="shouldShowSearchScope" :config="searchFiltersConfig" />
      </div>
    </div>
    <search-filters
      :config="searchFiltersConfig"
    />
    <datasets-info-box />
    <selectedFacetsOverview v-if="getFacets" :selected-facets="getFacets" :available-facets="getAllAvailableFacets" />
    <dataset-details-skeleton v-if="getLoading" type="Datasets" />
    <template v-if="!getLoading">
      <dataset-list-infos />
      <dataservices-list />
    </template>
  </section>
</template>

<script>

import {
  DatasetDetailsSkeleton,
  SelectedFacetsOverview,
} from "@piveau/piveau-hub-ui-modules";
import SearchFilters from "@/components/search/search-filters/SearchFilters";
import DataservicesList from "@/components/search/dataservices/DataservicesList";
import DatasetListInfos from "@/components/search/datasets/DatasetListInfos";
import DatasetsInfoBox from "@/components/search/datasets/DatasetsInfoBox";
import {mapGetters} from "vuex";
import SearchScopeSelectBar from "@/components/search/search-filters/SearchScopeSelectBar";

export default {
  name: "DataservicesContent",
  components: {
    SearchScopeSelectBar,
    SearchFilters,
    DatasetDetailsSkeleton,
    SelectedFacetsOverview,
    DataservicesList,
    DatasetListInfos,
    DatasetsInfoBox,
  },
  data() {
    return {
      searchFiltersConfig: {
        scope: "dataservice",
        apiFilter: 'filters=dataservice',
        apiQueryParams: 'resource=dataservice',
        textFieldHelpLink: `https://dataeuropa.gitlab.io/data-provider-manual/how-to-search/search-for-datasets/`,
        textKeys: {
          mobileSearchButton: 'message.datasets.ecd.filters.search',
          textFieldPlaceholder: 'message.search.searchBarPlaceholder.dataservice',
          count: "message.search.countMessage.dataservice",
          loading: "Loading Data services..."
        },
        getQuery: ["datasets", "getQuery"],
        setQuery: ["datasets", "setQuery"],
        setSort: ["datasets", "setSort"],
        getCount: ["search", "getDataserviceCount"],
        getLoading: ["datasets", "getLoading"],
        getFacets: ["datasets", "getFacets"],
      },
      useCombinedSearch: this.$env.content.useCombinedSearch
    }
  },
  computed: {
    ...mapGetters("datasets", ["getFacets", "getQuery", "getAllAvailableFacets",
      "getLoading", "getDatasetsCount"]),
    ...mapGetters("search", ["getShowFilter"]),
    shouldShowSearchScope() {
      if (this.$route.meta.hideSearchScope) return false;
      return this.useCombinedSearch;
    },
     contentClasses() {
      // Full width when facets are hidden or not in use
      if (!this.getShowFilter) {
         return 'col-12 px-lg-0 px-sm-2'; 
      }
      // Default classes when facets are shown
      return 'col-md-9 col-12';
    }
  }
}
</script>
